
var swiper = new Swiper("#bigs-v2-collectionslider", {
  slidesPerView:5,
  spaceBetween: 10,
  grabCursor:true,
  speed:800,
  autoplay:{
    delay:2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 2.1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween:10,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween:10,
    },
  },
});



var swiper = new Swiper("#bigs-v2-reviewslider", {
  slidesPerView:3,
    grabCursor:true,
  spaceBetween: 10,
    speed:800,
  autoplay:{
    delay:2500,
    disableOnInteraction: false,
  },
     navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  breakpoints: {
    0: {
      slidesPerView:1.2,
      spaceBetween: 10,
      centeredSlides: true,
      loop:true,
    },
    768: {
      slidesPerView: 4,
      spaceBetween:10,
      centeredSlides: false,
       loop:false,
    },
    1024: {
      slidesPerView:3,
      spaceBetween:10,
      centeredSlides: false,
      loop:false,
    },
  },
});



var swiper = new Swiper("#bigs-v2-blogs", {
  slidesPerView:4,
  spaceBetween: 20,
  grabCursor:true,
  speed:800,
  autoplay:{
    delay:2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView:1.2,
      spaceBetween: 10,
      centeredSlides: true,
      loop:true,
    },
    768: {
      slidesPerView: 3,
      spaceBetween:10,
      centeredSlides: false,
       loop:false,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:20,
      centeredSlides: false,
      loop:false,
    },
  },
});


  var swiper = new Swiper("#Mega-menu", {
    slidesPerView: "4",
    spaceBetween:10,
        speed:900,
    autoplay: {
    delay:3000,
    disableOnInteraction: false,
      },
          navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
     breakpoints: {
    0: {
      slidesPerView:1.5,
      spaceBetween:10,
    },
   768: {
      slidesPerView:3.5,
      spaceBetween:10,
    },
    1024: {
      slidesPerView:3.6,
      spaceBetween:10,
    },
    1500: {
      slidesPerView:4,
      spaceBetween:10,
    },
  },
  });




const toggleMenu = function toggleMenu(){
    var chk = document.querySelector('#checkbox');
    if (chk.checked) {
          document.body.classList.remove("big-open");
          document.querySelector("html").classList.remove("big-open");
                      document.querySelector("#search-icon").style.opacity = "1";
          document.querySelector("#search-icon").style.pointerEvents = "auto";
    } else {
          
        document.body.classList.add("big-open");
       document.querySelector("html").classList.add("big-open");
                document.querySelector("#search-icon").style.opacity = "0";
          document.querySelector("#search-icon").style.pointerEvents = "none";

    }
}




  var swiper = new Swiper("#big-banners", {
    slidesPerView: "1",
    spaceBetween:10,
        speed:900,
    loop:true,
    grabCursor:true,
    autoplay: {
    delay:3000,
    disableOnInteraction: false,
      },
          navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  });





// const nav = document.querySelector("#shopify-section-sections--15957067595974__header");
/*let nav = document.querySelector("#shopify-section-sections--16418894151878__header");
if(nav.length < 0){
  nav = document.querySelector("#shopify-section-sections--16425046147270__header");
}

const onScroll = (event) => {
  const scrollPosition = event.target.scrollingElement.scrollTop;

  nav.classList.toggle("new-fixed", scrollPosition > 70);
};

document.addEventListener("scroll", onScroll, { passive: true });*/




